import * as React from 'react';

import { ReactFCC } from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { IExpandableText } from './model';
import {
  Gradient,
  ExpandableTextWrapper,
  ExpandableTextButton,
} from './styled';

export const ExpandableText: ReactFCC<IExpandableText> = ({
  shouldShowFullText = false,
  buttonText,
  onClick,
  newPdDesignEnabled,
  children,
}) => {
  const newDesign = useNewPdDesignEnabled();
  return (
    <>
      <ExpandableTextWrapper
        shouldShowFullText={shouldShowFullText}
        newDesign={newDesign}
      >
        {children}

        {!shouldShowFullText && (
          <Gradient data-testid="expandable-text-gradient" />
        )}
      </ExpandableTextWrapper>

      {!shouldShowFullText && (
        <ExpandableTextButton
          newPdDesignEnabled={newPdDesignEnabled}
          data-testid="expandable-text-button"
          onClick={onClick}
        >
          {buttonText}
        </ExpandableTextButton>
      )}
    </>
  );
};
